import { ReactNode } from "react"
import styled, { css } from "styled-components"

import Typography from "~/components/atoms/Typography"
import { Color, IsMobile, LineHeight, SpacingSize } from "~/consts/style-mixins"

interface Props {
  children: ReactNode
  heading: string
  className?: string
  direction: keyof typeof DirectionType
}

export const DirectionType = {
  Horizontal: "Horizontal",
  Vertical: "Vertical",
}

interface StyledProps {
  styledByDirection: string
}

const DetailedExplanationItem = ({ children, heading, className, direction }: Props) => {
  return (
    <Container className={className} styledByDirection={styledByDirection[direction]}>
      <Typography type="Label" colorProp={Color.LightGray} className="head">
        {heading}
      </Typography>
      <Typography type="Description" colorProp={Color.Black} className="description">
        {children}
      </Typography>
    </Container>
  )
}

const styledByDirection = {
  Horizontal: `
    flex-direction: row;
    .description {
      width: calc(100% - 80px);
      margin-top: 0;
      line-height: ${LineHeight.S}%;
    }
    .head {
      width: 80px;
    }
  `,
  Vertical: `
    flex-direction: column;
  `,
}

const Container = styled.div`
  display: flex;
  padding: ${SpacingSize.XL}px 0;
  white-space: pre-line;
  ${IsMobile(css`
    padding: 16px 0;
  `)}
  &:not(:first-child) {
    border-top: solid 1px ${Color.BorderGray};
  }
  .description {
    margin-top: ${SpacingSize.XS}px;
  }
  ${({ styledByDirection }: StyledProps) => css`
    ${styledByDirection}
  `}
`

export default DetailedExplanationItem
